import React from "react";
import { func, node, oneOfType, shape, string } from "prop-types";

import getAvatarSrc from "src/shared/contact-boxes/utilities/getAvatarSrc";
import GlobalState from "src/shared/utilities/globalState";

class ConfirmationModal extends React.Component {
  componentDidMount() {
    const {
      confirmationHeader,
      confirmationText,
      formValues,
      handleContentClose,
      listedByName,
      rentalContact
    } = this.props;

    handleContentClose();

    const triggerScenario = GlobalState.get("triggerScenario");
    triggerScenario("ContactConfirmation", {
      confirmationHeader,
      confirmationText,
      email: formValues.email,
      agent: listedByName,
      agentUrl: this.props.rentalContact.account_url,
      logoUrl: getAvatarSrc(this.props.rentalContact),
      sourceGroup: rentalContact.business_name,
      origin: "contact_agent"
    });
  }

  render() {
    return null;
  }
}

ConfirmationModal.propTypes = {
  formValues: shape({
    preferredTourDate: string,
    timeOfDay: string,
    message: string,
    email: string
  }).isRequired,
  confirmationHeader: string,
  confirmationText: oneOfType([string, node]).isRequired,
  listedByName: string.isRequired,
  handleContentClose: func.isRequired,
  rentalContact: shape({
    business_name: string,
    image: shape({ url: string }),
    industry_professional: shape({ headshot: shape({ url: string }) }),
    name: string,
    phone: string,
    account_url: string
  }).isRequired
};

ConfirmationModal.defaultProps = {
  confirmationHeader: ""
};

export default ConfirmationModal;
